import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PhoneSpecs } from '../phones'

export type PhoneState = Array<PhoneSpecs>

export const phonesSlice = createSlice({
  name: 'phones',
  initialState: [] as Array<PhoneSpecs>,
  reducers: {
    setPhones: (state: PhoneState, action: PayloadAction<Array<PhoneSpecs>>) => {
      return action.payload
    },
  },
})

export const requestPhones = createAction('requestPhones')
export const { setPhones } = phonesSlice.actions
